import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

/**
 * Safety-net empty state shown wherever a location picker could legitimately be
 * empty (dashboard, items list, item form): a brand-new account with zero
 * locations, or an existing account whose auto-provisioned default location
 * failed to create at registration time.
 */
export function EmptyLocationsCta() {
  const { t } = useTranslation();
  return (
    <Card className="border-dashed">
      <CardContent className="flex flex-col items-center gap-3 p-8 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <Home className="h-6 w-6" aria-hidden="true" />
        </div>
        <div className="space-y-1">
          <h2 className="text-base font-semibold">{t('locations.emptyTitle')}</h2>
          <p className="text-sm text-muted-foreground">{t('locations.emptyBody')}</p>
        </div>
        <Button asChild>
          <RouterLink to="/locations">{t('locations.emptyCta')}</RouterLink>
        </Button>
      </CardContent>
    </Card>
  );
}
